import { TextField } from '@mui/material';
import { useFormContext } from 'react-hook-form';

export const BpInput = ({name, label, type}) => {
  const {register, formState: {errors}} = useFormContext();

  return <TextField variant="filled" label={label} type={type} {...register(name)} error={errors[name]} helperText={errors[name] && errors[name]["message"]} />
}